module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Completed Tasks: " + _vm._s(_vm.todos.filter(function (todo) {
    return todo.done === true
  }).length))]), _vm._v(" "), _c('p', [_vm._v("Pending Tasks: " + _vm._s(_vm.todos.filter(function (todo) {
    return todo.done === false
  }).length))]), _vm._v(" "), _vm._l((_vm.todos), function(todo) {
    return _c('todo', {
      attrs: {
        "todo": todo
      },
      on: {
        "delete-todo": _vm.deleteTodo,
        "complete-todo": _vm.completeTodo
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a9644e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TodoList.vue
// module id = 446
// module chunks = 1